import type { UserModel, UserSecurityInfoModel } from "../../models/user.models";
import { RequestClientService } from "./request-client.service";
import { autoinject } from "aurelia-dependency-injection";
import { ConfigService } from "./config.service";
import { SubscriptionTypeEnum } from "../../models/rightstore/rightstore.models";
import { CustomerSubscriptionService } from "./customer-subscription.service";

@autoinject()
export class UserClientService {

    public currentUser: UserModel;

    constructor(private requestClientService: RequestClientService, private configService: ConfigService,
        private customerSubscriptionService: CustomerSubscriptionService) { }

    public getMe(): Promise<UserSecurityInfoModel> {
        return this.requestClientService.get<UserSecurityInfoModel>(this.configService.config.urls.rightShipPlatformApiUrl + "/api/v1/me", {});
    }
    
    //Get current user from RightShipQi API
    public async getCurrentUser(): Promise<UserModel> {
        if (this.currentUser) {
            return this.currentUser;
        }
        else {
            try {
                this.currentUser = await this.requestClientService.get<UserModel>(this.configService.config.urls.rightShipPlatformApiUrl + "/api/v1/rightShipQiUser/GetMe", {});
                return this.currentUser;
            }
            catch (e) {
                console.error("Error getting current user", e);
                return null;
            }
        }
    }

    loadXSRFToken(): Promise<any> {
		return this.requestClientService.get<any>(this.configService.config.urls.rightShipPlatformApiUrl + '/api/v1/Auth0/LoadXSRFToken', {});
	}

    public async isLimitedCustomerSubscription(productCode: string, shouldCheckForVessels: boolean = false) {
        if (this.currentUser) {
            const response = await this.customerSubscriptionService.getMySubscription(productCode);
            return (response?.customerSubscription?.subscriptionTypeId === SubscriptionTypeEnum.LimitedSubscription || response?.customerSubscription?.isExpired) && 
                (!shouldCheckForVessels || !response?.customerSubscription?.metadata?.maxVesselsCount);
        }

        return false;
    }
}